export default "__VITE_ASSET__CmrOdtAz__"